//
// export const ToLocalStringConvert =(NumberValue:number | string) =>{
//     return NumberValue && (NumberValue).toLocaleString('en-US');
// }

export const ToLocalStringConvert = (NumberValue: number | string) => {
    return NumberValue
        ? NumberValue.toLocaleString('en-IN')
        : '0';
};